import { PageRouteBuilder } from "@common/route/page-route-builder";
import { PartnerListPageComponent } from "./partner-list-page.component";

export const displayPartnerListRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-partner-list-page", PartnerListPageComponent)
    .atUrl("/partners")
    .withTitle("Strategic Partners")
    .build();
